import { render, staticRenderFns } from "./SelectTuevsExam.vue?vue&type=template&id=4b67e97b&scoped=true&"
import script from "./SelectTuevsExam.vue?vue&type=script&lang=js&"
export * from "./SelectTuevsExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b67e97b",
  null
  
)

export default component.exports